import React from 'react';
import { SectionLoader as SectionLoaderSE } from '@gjensidige/se-section-loader';
import { useAppSelector } from '../../../hooks/appHooks';

export const SectionLoader: React.FunctionComponent = () => {
  const isUpdateOfferInProgress = useAppSelector(
    (state) => state.insurance.loading === 'updating'
  );

  return (
    <SectionLoaderSE
      spinnerText={'Laddar om pris…'}
      showLoader={isUpdateOfferInProgress}
    />
  );
};
